import React from 'react';
import { MessageBar, MessageBarBody } from '@fluentui/react-components';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';

interface IErrorMessageProps {
  children: JSX.Element;
}

const ErrorMessage = ({ children }: IErrorMessageProps): JSX.Element => {
  return (
    <MessageBar intent="error" layout="multiline">
      <MessageBarBody>
        <Stack tokens={{ childrenGap: 10 }}>{children}</Stack>
      </MessageBarBody>
    </MessageBar>
  );
};

export default ErrorMessage;
